import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=5e60781a&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e60781a')) {
      api.createRecord('5e60781a', component.options)
    } else {
      api.reload('5e60781a', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=5e60781a&", function () {
      api.rerender('5e60781a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/popups/confirm.vue"
export default component.exports